import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
// redux
import { connect } from 'react-redux';
import { signUpRequest } from '../../redux/reducers/auth';
// components
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import SignUpForm from './components/SignUpForm';
import Stepper from './components/Stepper/Stepper';
import SignUpConfirmation from './components/SignUpConfirmation';
// utils
import queryString from 'query-string';
// styles
import styles from './SignUp.mod.css';

class SignUp extends Component {
  getActiveStep = () => {
    const { pathname } = this.props.location;
    const steps = {
      username: 0,
      gender: 1,
      birthdate: 2,
      statement: 3,
    };
    const page = pathname.split('/').reverse()[0];
    return steps[page];
  };

  render() {
    const {
      user,
      signUpRequest,
      location: { search },
      isLogged,
      history,
    } = this.props;

    if (user.id && isLogged) {
      history.push('/dashboard');
    }

    const query = queryString.parse(search);

    return (
      <div>
        <Stepper value={this.getActiveStep()} />
        <PageWrapper className={styles.container}>
          <Switch>
            <Route
              exact
              path="/signup"
              render={props => (
                <SignUpForm
                  onSubmit={signUpRequest}
                  user={user}
                  support={query['support']}
                  {...props}
                />
              )}
            />
            <Route path="/signup/confirmation" component={SignUpConfirmation} />
            <Redirect to="/" />
          </Switch>
        </PageWrapper>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.auth.user || {},
    isLogged: state.auth.authenticated,
  }),
  { signUpRequest }
)(SignUp);



// WEBPACK FOOTER //
// ./src/containers/SignUp/SignUp.jsx